export const whatsappLink = "https://wa.me/5516992947576?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20a%20Lightcon.";